const ZOOM_MIN_SECTIONS = 8.8;
const FLYTOHOME_DURATION = 50;

export default {ZOOM_MIN_SECTIONS, FLYTOHOME_DURATION};
